<template>
  <div class="container">
    <section class="article-search">
      <div class="search-wapper">
        <h3>
          <span class="search-title-divider" aria-hidden="true"></span>
          <span class="search-title-text">{{ !sysName || sysName === "null" ? "外文学术资源数据库" : sysName }}</span>
          <span class="search-title-divider" aria-hidden="true"></span>
        </h3>
        <div class="search flex">
          <div>
            <div class="flex search_div">
              <el-select class="title-select" :popper-append-to-body="false" v-model="searchFields" placeholder="请选择" @change="handleChangeSelect">
                <el-option v-for="(item, index) in searchOptions" :key="index" :label="item.showName" :value="item.autoCompletionFieldName"></el-option>
              </el-select>
              <div class="searchLeft flex">
                <div class="inputDiv flex">
                  <el-input v-model="searchWord" clearable maxlength="1000" @keyup.enter.native="toSearch" placeholder="请输入要检索的内容" @input="getKeywordData(1)" @focus="showSearchInput" @blur="hideSearchInput"></el-input>
                  <div @click="toSearch" class="search-btn">
                    <img src="../../assets/images/icon-js.png" />
                  </div>
                </div>
                <div class="search-input" v-if="searchFlag" @click.stop>
                  <ul>
                    <li v-for="(item, index) in keywordDataList" :key="index" @click="toSearchKeyword(index)" v-safe-html="item.suggestionWord"></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="search_nav">当前位置：首页 > <span>学者</span></div>
      </div>
    </section>
    <div class="w1380 flex">
      <div class="left_list">
        <div v-if="leftLoading && leftData.length === 0" class="author-filter-skeleton" aria-label="筛选条件加载中">
          <div v-for="group in 3" :key="group" class="filter-skeleton-group">
            <span class="skeleton-line filter-title"></span>
            <span v-for="line in 5" :key="line" class="skeleton-line filter-line"></span>
          </div>
        </div>
        <AuthorLeftMenu v-show="leftData.length > 0" :leftData="leftData" :showLetterFlag="showLetter" :delName="delName" @childByValue="childByValue"></AuthorLeftMenu>
      </div>
      <div class="right_list">
        <!-- 检索 -->
        <div class="right-top">
          <p class="filter mbborder" v-if="searchWord">
            <span class="searchword" v-if="searchWord">
              检索结果：“<label class="red">{{ searchData }}</label
              >”（<label class="red">{{ totalData }}</label
              >条记录）
            </span>
          </p>
          <div class="filter">
            筛选条件：
            <label v-for="(item, index) in conData" :key="index" class="flex">
              {{ item.fatherName }}: {{ item.name }}
              <i class="el-icon-close" @click="delName = item"></i>
            </label>
          </div>
        </div>
        <!-- 排序 -->
        <div class="sort-item">
          <p v-for="(item, index) in sortList" :class="{ checked: sortIndex == index }" :key="index" @click="handleChangeSort(index)">
            {{ item.label }}
          </p>
        </div>
        <!-- 列表 -->
        <div class="right-info">
          <ul v-if="loading" class="author-list-skeleton" aria-label="学者列表加载中">
            <li v-for="item in 5" :key="item" class="author-skeleton-item">
              <span class="skeleton-line skeleton-index"></span>
              <div class="skeleton-content">
                <span class="skeleton-line skeleton-name"></span>
                <div class="skeleton-metrics">
                  <span v-for="metric in 3" :key="metric" class="skeleton-line skeleton-metric"></span>
                </div>
                <span class="skeleton-line skeleton-detail skeleton-detail-long"></span>
                <span class="skeleton-line skeleton-detail"></span>
                <div class="skeleton-actions">
                  <span v-for="action in 4" :key="action" class="skeleton-line skeleton-action"></span>
                </div>
              </div>
            </li>
          </ul>
          <ul v-else class="right-list">
            <li v-for="(item, index) in listData" :key="index" :data-author-sid="item.sid">
              <span class="right_index">{{ (pageNo - 1) * pageSize + index + 1 }}、</span>
              <div class="right-content">
                <div class="title" @click="toAuthorDetail(item.sid)" v-safe-html="item.authorName"></div>
                <div class="num">
                  <span>H-index：{{ item.hindex }}</span
                  ><span>论文数：{{ item.worksCount }}</span
                  ><span>引用数：{{ item.citedByCount }}</span>
                </div>
                <p v-if="item.lastKnownInstitutionName">所属机构：<span v-safe-html="item.lastKnownInstitutionName"></span></p>
                <p v-if="item.primayConcepts && item.primayConcepts.length > 0">
                  研究领域：<span v-for="(element, idx) in item.primayConcepts" :key="idx"> <span class="hover" @click="toPrimaySearch(element)" v-safe-html="element"></span><span v-if="idx < item.primayConcepts.length - 1">；</span></span>
                </p>
                <div class="setting">
                  <div class="setting-span">
                    <span :class="{ checked: listData[index].relation == true }" @click="toPublicList(index, 'relation')"><i class="el-icon-s-operation"></i>相关论文</span>
                    <span :class="{ checked: listData[index].latest == true }" @click="toPublicList(index, 'latest')"><i class="el-icon-s-platform"></i>最新动态</span>
                    <span :class="{ checked: listData[index].achievement == true }" @click="toPublicList(index, 'achievement')"><i class="el-icon-s-order"></i>代表成果</span>
                    <span :class="{ checked: listData[index].author == true }" @click="getAuthorList(index, 'author')"><i class="el-icon-s-custom"></i>相似学者</span>
                  </div>
                  <template v-if="!info.ipUser">
                    <el-tooltip class="item" effect="dark" content="关注获取Ta的最新动态" placement="top-start">
                      <span class="follow" v-if="!item.share" @click="isCollectshow(item)">
                        <i class="el-icon-circle-plus-outline"></i>关注<label v-if="item.shareCount > 0">{{ item.shareCount }}</label>
                      </span>
                    </el-tooltip>
                    <span class="follow collect" v-if="item.share" @click="cancelCollect(item)">
                      <i class="el-icon-circle-plus-outline"></i>已关注<label v-if="item.shareCount > 0">{{ item.shareCount }}</label>
                    </span>
                  </template>
                </div>

                <div class="chindren-page result-loading" v-if="item.publicLoading">
                  <i class="el-icon-loading"></i>
                  <span>加载中...</span>
                </div>
                <!-- 相关论文 -->
                <div class="chindren-page1 chindren-page" v-if="!item.publicLoading && item.relation && item.publicList && item.publicList.length > 0">
                  <div class="page1-list" v-for="(element, idx) in item.publicList" :key="idx">
                    <p class="page1-title" @click="toArticleDetail(element.sid)" v-safe-html="element.title"></p>
                    <div class="author-list-container">
                      <div class="span-content" :class="{ green_span: list.click }" v-for="(list, idx) in element.authorList" :key="idx">
                        <span class="span_a" v-safe-html="list.authorName" @click="toPaperAuthorDetail(list)"></span>
                        <span v-if="idx < element.authorList.length - 1">；</span>
                        <div class="author1-content">
                          <p class="mb10" v-safe-html="list.authorName"></p>
                          <p>
                            <span v-if="list.hindex != null"
                              >hindex：<label>{{ list.hindex }}</label></span
                            >
                            <span v-if="list.i10Index != null"
                              >i10Index：<label>{{ list.i10Index }}</label></span
                            >
                          </p>
                          <p>
                            <span v-if="list.citedByCount != null"
                              >citedByCount：<label>{{ list.citedByCount }}</label></span
                            >
                            <span v-if="list.worksCount != null"
                              >worksCount：<label>{{ list.worksCount }}</label></span
                            >
                          </p>
                          <p class="hui">{{ list.lastKnownInstitutionName }}</p>
                        </div>
                      </div>
                    </div>
                    <p class="small">
                      引用量：<span class="count">{{ element.citedCount }}</span>
                    </p>
                  </div>
                </div>
                <div class="chindren-page empty-result" v-if="!item.publicLoading && item.relation && (!item.publicList || item.publicList.length === 0)">暂无相关论文</div>
                <!-- 最新动态 -->
                <div class="chindren-page2 chindren-page" v-if="!item.publicLoading && item.latest && item.publicList && item.publicList.length > 0">
                  <div class="children-list" v-for="(element, idx) in item.publicList" :key="idx">
                    <p>{{ element.publishDate }}</p>
                    <p class="page2-title" v-safe-html="element.title" @click="toArticleDetail(element.sid)"></p>
                  </div>
                </div>
                <div class="chindren-page empty-result" v-if="!item.publicLoading && item.latest && (!item.publicList || item.publicList.length === 0)">暂无最新动态</div>
                <!-- 代表成果 -->
                <div class="chindren-page2 chindren-page" v-if="!item.publicLoading && item.achievement && item.publicList && item.publicList.length > 0">
                  <div class="children-list" v-for="(element, idx) in item.publicList" :key="idx">
                    <p>{{ element.publishDate }}</p>
                    <p class="page2-title" v-safe-html="element.title" @click="toArticleDetail(element.sid)"></p>
                    <p class="small">
                      引用量：<span class="count">{{ element.citedCount }}</span>
                    </p>
                  </div>
                </div>
                <div class="chindren-page empty-result" v-if="!item.publicLoading && item.achievement && (!item.publicList || item.publicList.length === 0)">暂无代表成果</div>
                <!-- 相似作者 -->
                <div class="chindren-page2 chindren-page" v-if="!item.publicLoading && item.author && item.publicList && item.publicList.length > 0">
                  <div class="children-list" v-for="(element, idx) in item.publicList" :key="idx">
                    <p class="page2-title" v-safe-html="element.authorName" @click="toAuthorDetail(element.sid)"></p>
                    <div class="author-content">
                      <p class="mb10" v-safe-html="element.authorName"></p>
                      <p>
                        <span v-if="element.hindex != null"
                          >hindex：<label>{{ element.hindex }}</label></span
                        >
                        <span v-if="element.i10Index != null"
                          >i10Index：<label>{{ element.i10Index }}</label></span
                        >
                      </p>
                      <p>
                        <span v-if="element.citedByCount != null"
                          >citedByCount：<label>{{ element.citedByCount }}</label></span
                        >
                        <span v-if="element.worksCount != null"
                          >worksCount：<label>{{ element.worksCount }}</label></span
                        >
                      </p>
                      <p class="hui">{{ element.lastKnownInstitutionName }}</p>
                    </div>
                  </div>
                </div>
                <div class="chindren-page empty-result" v-if="!item.publicLoading && item.author && (!item.publicList || item.publicList.length === 0)">暂无相似学者</div>
              </div>
            </li>
          </ul>
          <div class="noData" v-if="!loading && total <= 0">
            <img src="../../assets/images/noData.png" />
          </div>
          <el-pagination v-if="!loading" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo" :page-sizes="[10, 20, 30, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" hide-on-single-page> </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog title="关注" :visible.sync="referenceCollect" width="30%">
      <div class="follow-btn-box">
        <el-button type="primary" class="follow-btn" @click="handleOnlyFollow"><i class="el-icon-plus"></i> 仅关注</el-button>
        <el-button type="primary" class="follow-btn subscribe-btn" @click="handleFollowAndSubscribe"><i class="el-icon-bell"></i> 关注并订阅动态</el-button>
        <el-button class="follow-btn cancel-btn" @click="isCancel">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import AuthorLeftMenu from "@/components/authorLeftMenu.vue";
export default {
  components: { AuthorLeftMenu },
  data() {
    return {
      loading: true,
      leftLoading: true,
      showLetter: false, //左侧聚合是否显示首字母
      delName: null,
      pageNo: 1,
      pageSize: 10,
      searchWord: "",
      searchData: "",
      leftData: [],
      total: 0,
      totalData: 0,
      listData: [],
      sortVal: "_score",
      filterData: [],
      conData: [], //条件的过滤
      sortIndex: 0,
      sortList: [
        {
          label: "相关度",
          value: "_score",
        },
        {
          label: "h指数",
          value: "hIndex",
        },
        {
          label: "引用数",
          value: "citedByCount",
        },
        {
          label: "论文数",
          value: "worksCount",
        },
      ],
      searchOptions: [],
      searchFields: "",
      publicList: [],

      info: null,
      outSid: "",
      referenceCollect: false,
      checkSubscribe: "0", //0：不订阅 1：订阅 默认传0
      searchFlag: false, // 控制联想词列表显示隐藏
      keywordDataList: [], // 存储联想词数据
      sysName: "",
      itemRestoreTimers: [],
      pendingRestoreSid: "",
    };
  },
  created() {},
  mounted() {
    if (localStorage.getItem("sysName")) {
      this.sysName = localStorage.getItem("sysName");
    } else if (localStorage.getItem("systemName")) {
      this.sysName = localStorage.getItem("systemName");
    }
    if (sessionStorage.getItem("search-author-keyword")) {
      let obj = JSON.parse(sessionStorage.getItem("search-author-keyword"));
      this.searchWord = obj.word;
      this.searchData = obj.word;
    }
    this.getSearchOptions();
    this.getInfo();
  },
  activated() {
    if (this.applyPendingDomainSearch()) {
      sessionStorage.removeItem("chongda_skip_restore_once");
      sessionStorage.removeItem("chongda_author_should_restore");
      return;
    }
    if (sessionStorage.getItem("chongda_skip_restore_once") === this.$route.path) {
      sessionStorage.removeItem("chongda_skip_restore_once");
      sessionStorage.removeItem("chongda_author_should_restore");
      this.$nextTick(() => {
        [0, 80, 180, 400, 800, 1200].forEach(delay => {
          setTimeout(() => {
            this.scrollPageToTop();
            this.resetInnerScrollableElements();
          }, delay);
        });
      });
      return;
    }
    if (sessionStorage.getItem("chongda_author_should_restore") === "1") {
      sessionStorage.removeItem("chongda_author_should_restore");
      this.$nextTick(() => {
        this.restoreSavedAnchorRepeatedly();
      });
    }
  },
  deactivated() {
    this.clearItemRestoreTimers();
  },
  beforeRouteLeave(to, from, next) {
    this.saveCurrentRestoreAnchor(to.name === "authorDetail" ? this.pendingRestoreSid : "");
    this.pendingRestoreSid = "";
    this.clearItemRestoreTimers();
    next();
  },
  methods: {
    getStoredAuthorSearch() {
      const value = sessionStorage.getItem("search-author-keyword");
      if (!value) {
        return null;
      }
      try {
        return JSON.parse(value);
      } catch (error) {
        sessionStorage.removeItem("search-author-keyword");
        return null;
      }
    },
    applyPendingDomainSearch() {
      const search = this.getStoredAuthorSearch();
      const domainOption = this.searchOptions[2];
      if (!search || search.form !== "domain" || !search.pending || !domainOption) {
        return false;
      }

      this.searchWord = String(search.word || "");
      this.searchData = this.searchWord;
      this.searchFields = domainOption.autoCompletionFieldName;
      this.pageNo = 1;
      this.filterData = [];
      this.conData = [];
      this.sortIndex = 0;
      this.sortVal = this.sortList[0].value;
      this.searchFlag = false;

      sessionStorage.setItem(
        "search-author-keyword",
        JSON.stringify({
          word: this.searchWord,
          form: "domain",
          pending: false,
        }),
      );

      this.getLeftData();
      this.getList();
      this.$nextTick(() => this.scrollPageToTop());
      return true;
    },
    clearItemRestoreTimers() {
      this.itemRestoreTimers.forEach(timer => clearTimeout(timer));
      this.itemRestoreTimers = [];
    },
    getScrollTargets() {
      const elements = [document.getElementById("subapp-container"), document.querySelector(".view"), document.scrollingElement, document.documentElement, document.body].filter(Boolean);
      return elements.filter((element, index) => elements.indexOf(element) === index);
    },
    scrollPageToTop() {
      this.getScrollTargets().forEach(element => {
        element.scrollTop = 0;
      });
      window.scrollTo(0, 0);
    },
    resetInnerScrollableElements() {
      const nodes = this.$el && this.$el.querySelectorAll ? Array.from(this.$el.querySelectorAll("*")) : [];
      nodes.forEach(element => {
        const style = window.getComputedStyle(element);
        const canScroll = element.scrollHeight > element.clientHeight;
        const allowsScroll = style.overflowY === "auto" || style.overflowY === "scroll" || style.overflowY === "overlay";
        if (canScroll || allowsScroll) {
          element.scrollTop = 0;
        }
      });
    },
    adjustPageScrollBy(delta) {
      if (!delta) {
        return;
      }
      this.getScrollTargets().forEach(element => {
        element.scrollTop += delta;
      });
      window.scrollBy(0, delta);
    },
    getVisibleRestoreItem() {
      const items = this.$el && this.$el.querySelectorAll ? Array.from(this.$el.querySelectorAll("[data-author-sid]")) : [];
      if (!items.length) {
        return null;
      }
      const visibleItem = items.find(item => {
        const rect = item.getBoundingClientRect();
        return rect.bottom > 0 && rect.top < window.innerHeight;
      });
      return visibleItem || items[0];
    },
    saveCurrentRestoreAnchor(preferredSid) {
      let target = null;
      if (preferredSid && this.$el && this.$el.querySelector) {
        target = this.$el.querySelector(`[data-author-sid="${preferredSid}"]`);
      }
      if (!target) {
        target = this.getVisibleRestoreItem();
      }
      if (!target) {
        return;
      }
      const sid = target.getAttribute("data-author-sid");
      const rect = target.getBoundingClientRect();
      sessionStorage.setItem(
        "chongda_author_restore_anchor",
        JSON.stringify({
          sid,
          offsetTop: rect.top,
        }),
      );
      sessionStorage.setItem("chongda_author_should_restore", "1");
    },
    restoreSavedAnchorRepeatedly() {
      const anchorText = sessionStorage.getItem("chongda_author_restore_anchor");
      if (!anchorText) {
        return;
      }
      let anchor = null;
      try {
        anchor = JSON.parse(anchorText);
      } catch (error) {
        return;
      }
      if (!anchor || !anchor.sid) {
        return;
      }
      this.clearItemRestoreTimers();
      [0, 80, 180, 320, 500].forEach(delay => {
        const timer = setTimeout(() => {
          const target = this.$el && this.$el.querySelector ? this.$el.querySelector(`[data-author-sid="${anchor.sid}"]`) : null;
          if (target && target.scrollIntoView) {
            target.scrollIntoView({ block: "start", behavior: "auto" });
            const currentTop = target.getBoundingClientRect().top;
            this.adjustPageScrollBy(currentTop - Number(anchor.offsetTop || 0));
          }
        }, delay);
        this.itemRestoreTimers.push(timer);
      });
    },
    getInfo() {
      this.$http({
        url: "api/v1/user/info",
        method: "POST",
      }).then(res => {
        this.info = res.data;
      });
    },
    // 检索方式切换
    handleChangeSelect() {
      // this.searchWord = "";
    },
    toSearch() {
      if (!this.searchWord.trim()) {
        // 如没有输入检索词 获取上一次搜索词 进行检索
        if (sessionStorage.getItem("search-author-keyword")) {
          let obj = JSON.parse(sessionStorage.getItem("search-author-keyword"));
          this.searchWord = obj.word;
          this.searchData = obj.word;
        }
      } else {
        sessionStorage.setItem(
          "search-author-keyword",
          JSON.stringify({
            word: this.searchWord.trim(),
          }),
        );
      }
      this.searchData = this.searchWord;
      this.pageNo = 1;
      this.getLeftData();
      this.getList();
    },
    toPrimaySearch(val) {
      let item = val.split("<span style='color:red'>").join("").split("</span>").join("");
      this.searchWord = item;
      this.searchFields = this.searchOptions[2].autoCompletionFieldName;
      this.toSearch();
    },
    getSearchOptions() {
      this.$http({
        url: "api/v1/reception/author/dropDownList",
        method: "post",
      }).then(res => {
        if (res.code == 200) {
          this.searchOptions = res.data;
          this.searchOptions = res.data.map(item => {
            return {
              ...item,
              showName: item.showName.replace("作者名称", "学者名称").replace("作者机构", "学者机构"),
            };
          });
          this.searchFields = this.searchOptions[0].autoCompletionFieldName;

          // 点击了详情页的领域 跳转过来的
          if (sessionStorage.getItem("search-author-keyword")) {
            let obj = JSON.parse(sessionStorage.getItem("search-author-keyword"));
            if (obj.form && obj.form == "domain") {
              this.searchFields = this.searchOptions[2].autoCompletionFieldName;
            }
          }
          if (!this.applyPendingDomainSearch()) {
            this.getLeftData();
            this.getList();
          }
        }
      });
    },
    getLeftData() {
      this.leftLoading = true;
      let array = [];

      this.filterData.forEach(element => {
        array.push({
          filterField: element.filterField,
          filterValue: element.filterValue,
        });
      });
      let postBody = {
        searchWord: this.searchWord.trim(),
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        orderField: this.sortVal,
        orderType: "DESC",
        metricFilterList: array,
        searchFields: this.searchFields ? [this.searchFields] : [],
      };
      this.$http({
        url: "api/v1/reception/author/authorListAgg",
        method: "post",
        data: postBody,
      })
        .then(res => {
          if (res.code == 200) {
            res.data.left.forEach(element => {
              element.dropNum = 5;
            });
            this.leftData = res.data.left;
          }
        })
        .finally(() => {
          this.leftLoading = false;
        });
    },
    getList() {
      let array = [];
      this.loading = true;

      this.filterData.forEach(element => {
        array.push({
          filterField: element.filterField,
          filterValue: element.filterValue,
        });
      });
      let postBody = {
        searchWord: this.searchWord.trim(),
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        orderField: this.sortVal,
        orderType: "DESC",
        metricFilterList: array,
        searchFields: this.searchFields ? [this.searchFields] : [],
      };
      this.$http({
        url: "api/v1/reception/author/authorList",
        method: "post",
        data: postBody,
      }).then(res => {
        this.loading = false;
        if (res.code == 200) {
          this.totalData = res.data.recordCount;
          this.total = res.data.recordCount > 10000 ? 10000 : res.data.recordCount;
          this.listData = res.data.recordList;
          // 自定义浏览器tab页签内容
          let text = this.searchWord + " - jyx search";
          // document.querySelector("head title").innerText = text;
        }
      });
    },
    childByValue(val) {
      this.pageNo = 1;
      this.filterData = val.newNarr;
      this.conData = val.filterArray;
      this.getList();
      // 这里去掉 this.getLeftData(); 因为在左侧组件中点击筛选项时，如果不重新获取左侧数据，
      // 就不会导致左侧组件被完全销毁重建，从而避免 Cannot read properties of undefined (reading '$children') 报错。
      // 左侧数据通常在此时不需要完全重刷，或者需要等接口返回再刷新
    },
    // 排序
    handleChangeSort(index) {
      this.sortIndex = index;
      this.sortVal = this.sortList[this.sortIndex].value;
      this.pageNo = 1;
      this.getLeftData();
      this.getList();
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.pageNo = 1;
      this.pageSize = val;
      this.getList();
    },
    isCancel() {
      this.referenceCollect = false;
    },

    // 仅关注
    handleOnlyFollow() {
      this.checkSubscribe = "0";
      this.isCollect();
    },

    // 关注并订阅动态
    handleFollowAndSubscribe() {
      this.checkSubscribe = "1";
      this.isCollect();
    },
    // 取消/关注 关注接口
    isCollectshow(item) {
      this.outSid = item.sid;
      this.checkSubscribe = "0";
      this.referenceCollect = true;
    },
    cancelCollect(item) {
      this.outSid = item.sid;
      this.checkSubscribe = 0;
      this.isCollect();
    },
    isCollect() {
      this.referenceCollect = false;
      let postBody = {
        outSid: this.outSid,
        type: 3,
        subscribe: this.checkSubscribe,
      };
      this.$http({
        url: "api/v1/usershare/collect",
        method: "post",
        data: postBody,
      }).then(res => {
        if (res.code == 200) {
          this.getList();
        }
      });
    },

    toPublicList(index, val) {
      const author = this.listData[index];
      const requestId = (author.publicRequestId || 0) + 1;
      this.$set(author, "publicRequestId", requestId);
      this.$set(author, "publicLoading", true);
      this.$http({
        url: `api/v1/reception/author/authorPaperList?authorSid=${author.sid}&type=${val}`,
        // url: `api/v1/reception/author/authorPaperList?authorSid=https://openalex.org/A5059683644&type=${val}`,
        method: "get",
      }).then(res => {
        if (res.code == 200 && author.publicRequestId === requestId) {
          author.publicList = Array.isArray(res.data) ? res.data : [];
          // 相关论文  显示 /隐藏
          if (val == "relation") {
            if (!author.relation) {
              author.relation = true;
              author.latest = false;
              author.achievement = false;
              author.author = false;
            } else {
              author.relation = false;
            }
            this.$forceUpdate();
          }
          // 最新动态
          if (val == "latest") {
            if (!author.latest) {
              author.latest = true;
              author.relation = false;
              author.achievement = false;
              author.author = false;
            } else {
              author.latest = false;
            }
            this.$forceUpdate();
          }
          // 代表成果
          if (val == "achievement") {
            if (!author.achievement) {
              author.relation = false;
              author.latest = false;
              author.author = false;
              author.achievement = true;
            } else {
              author.achievement = false;
            }
            this.$forceUpdate();
          }
        }
      }).finally(() => {
        if (author.publicRequestId === requestId) {
          this.$set(author, "publicLoading", false);
        }
      });
    },
    getAuthorList(index, val) {
      const author = this.listData[index];
      const requestId = (author.publicRequestId || 0) + 1;
      this.$set(author, "publicRequestId", requestId);
      this.$set(author, "publicLoading", true);
      this.$http({
        url: `api/v1/reception/author/similarAuthorList?authorSid=${author.sid}&size=5`,
        method: "get",
      }).then(res => {
        if (res.code == 200 && author.publicRequestId === requestId) {
          author.publicList = Array.isArray(res.data) ? res.data : [];
          if (!author.author) {
            author.relation = false;
            author.latest = false;
            author.achievement = false;
            author.author = true;
          } else {
            author.author = false;
          }
          this.$forceUpdate();
        }
      }).finally(() => {
        if (author.publicRequestId === requestId) {
          this.$set(author, "publicLoading", false);
        }
      });
    },
    toArticleDetail(sid) {
      let _url = this.$router.resolve({
        path: "/articleDetail",
        query: { sid: sid },
      });
      window.open(_url.href, "_blank");
    },
    toHome() {
      this.$router.push({ path: "/articleSearch" });
    },
    toAuthorDetail(authorSid) {
      this.pendingRestoreSid = String(authorSid);
      this.$router.push({
        path: "/authorDetail",
        query: { authorSid: authorSid },
      });
    },
    toPaperAuthorDetail(item) {
      if (item.click) {
        if (window.__POWERED_BY_QIANKUN__) {
          // 在 Qiankun 主应用环境中，跳转主应用的路由（使用当前所在主应用的域名）
          const url = window.location.origin + `/authorDetail?authorSid=${item.sid}`;
          window.open(url, "_self");
        } else {
          // 独立运行时的跳转
          window.open(baseurl.jyxUrl + `authorDetail?authorSid=${item.sid}`, "_self");
        }
      }
    },
    // 根据输入的内容获取联想数据
    getKeywordData() {
      // 根据当前激活的tab选择对应的关键词
      if (!this.searchWord.trim()) {
        this.searchFlag = false;
        return;
      }
      let postBody = {
        word: this.searchWord,
        autoCompletionFieldName: "author",
      };
      this.$http({
        url: `api/v1/reception/journalpaper/suggestion`,
        method: "post",
        data: postBody,
      }).then(res => {
        if (res.code == 200) {
          if (res.data.length == 0) {
            this.searchFlag = false;
          } else {
            this.keywordDataList = res.data;
            this.searchFlag = true;
          }
        }
      });
    },
    // 点击联想关键词事件
    toSearchKeyword(index) {
      sessionStorage.removeItem("search-author-keyword");
      let searchWords = this.keywordDataList[index].suggestionWord.split("<span style='color:#15babc'>").join("").split("</span>").join("");
      sessionStorage.setItem(
        "search-author-keyword",
        JSON.stringify({
          word: searchWords,
        }),
      );
      this.searchData = searchWords;
      this.searchWord = searchWords;
      this.pageNo = 1;
      this.searchFlag = false;
      this.getLeftData();
      this.getList();
    },

    // 控制联想框显示
    showSearchInput() {
      if (this.searchWord && this.keywordDataList.length > 0) {
        this.searchFlag = true;
      }
    },

    // 控制联想框隐藏
    hideSearchInput() {
      // 使用setTimeout延迟隐藏，以便点击联想词时能触发点击事件
      setTimeout(() => {
        this.searchFlag = false;
      }, 200);
    },
  },
};
</script>

<style scoped lang="scss">
.skeleton-line {
  display: block;
  border-radius: 3px;
  background: linear-gradient(90deg, #eef1f5 25%, #f7f8fa 37%, #eef1f5 63%);
  background-size: 400% 100%;
  animation: author-skeleton-loading 1.4s ease infinite;
}

@keyframes author-skeleton-loading {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}

.author-filter-skeleton {
  width: 250px;
  flex: 0 0 250px;
  margin-right: 20px;

  .filter-skeleton-group {
    padding: 18px 20px;
    margin-bottom: 10px;
    background: #fff;
  }

  .filter-title {
    width: 42%;
    height: 18px;
    margin-bottom: 20px;
  }

  .filter-line {
    width: 100%;
    height: 14px;
    margin-top: 14px;

    &:nth-child(2n) {
      width: 78%;
    }
  }
}

.author-list-skeleton {
  margin: 0;
  padding: 0;

  .author-skeleton-item {
    display: flex;
    padding: 24px 0;
    border-bottom: 1px dashed #e8ebef;
  }

  .skeleton-index {
    flex: 0 0 28px;
    width: 28px;
    height: 18px;
    margin: 3px 20px 0 0;
  }

  .skeleton-content {
    flex: 1;
    min-width: 0;
  }

  .skeleton-name {
    width: 22%;
    min-width: 120px;
    height: 20px;
  }

  .skeleton-metrics,
  .skeleton-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    margin-top: 16px;
  }

  .skeleton-metric {
    width: 110px;
    height: 14px;
  }

  .skeleton-detail {
    width: 48%;
    height: 14px;
    margin-top: 16px;
  }

  .skeleton-detail-long {
    width: 68%;
  }

  .skeleton-actions {
    padding-top: 16px;
    border-top: 1px solid #f0f1f3;
  }

  .skeleton-action {
    width: 88px;
    height: 16px;
  }
}

@media (max-width: 1024px) {
  .author-filter-skeleton {
    width: 100%;
    flex-basis: 100%;
    margin-right: 0;
    margin-bottom: 12px;
  }
}

@media (max-width: 768px) {
  .author-list-skeleton {
    .author-skeleton-item {
      padding: 18px 0;
    }

    .skeleton-index {
      flex-basis: 22px;
      width: 22px;
      margin-right: 10px;
    }

    .skeleton-name,
    .skeleton-detail,
    .skeleton-detail-long {
      width: 80%;
      min-width: 0;
    }

    .skeleton-metric,
    .skeleton-action {
      width: 78px;
    }
  }
}

.container {
  min-height: calc(100vh);
  .article-search {
    width: 100%;
    padding-top: 40px;
    height: 240px;
    background: url("../../assets/images/search_bg.png") no-repeat;
    background-size: 100% 100%;
    .search-wapper {
      width: calc(100% - 40px);
      max-width: 1380px;
      min-width: 0;
      margin: 0 auto;
      position: relative;
      height: 100%;
    }
    h3 {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 12px;
      text-align: center;
      font-weight: normal;
      font-size: 26px;
      font-family: "宋体";
      .search-title-divider {
        flex: 0 0 26px;
        height: 1px;
        background-color: #cccccc;
      }
      .search-title-text {
        min-width: 0;
        overflow-wrap: anywhere;
      }
    }
    .search {
      align-items: center;
      justify-content: center;
      .search_div {
        align-items: center;
        margin-top: 30px;
        margin-bottom: 15px;
        position: relative;
        a {
          font-size: 18px;
          text-decoration: underline;
          &:hover {
            text-decoration: underline;
          }
        }
        .title-select {
          width: 130px;
          margin-right: 10px;
          ::v-deep .el-input__inner {
            height: 48px;
            border: 1px solid #ccc;
            border-radius: 0;
          }
        }
      }
      .searchLeft {
        border: 1px solid #cccccc;
        width: min(700px, calc(100vw - 240px));
        min-width: 0;
        height: 48px;
        background: #fff;
        position: relative;
        ::v-deep .el-input__inner {
          border: none;
          height: 48px;
          background: none;
          border-radius: 0;
        }
        .el-select {
          position: relative;
          width: 110px;
        }
        .inputDiv {
          align-items: center;
          flex: 1;
          background: #fff;
          ::v-deep .el-input {
            flex: 1;
          }
          .default {
            cursor: not-allowed !important;
          }
          .search-btn {
            cursor: pointer;
            margin-right: 4px;
            width: 66px;
            height: 40px;
            background: #2d8cf0;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }
      a {
        color: #2d8cf0;
        margin-left: 10px;
      }
    }
    .search_nav {
      color: #999999;
      font-size: 14px;
      position: absolute;
      left: 0;
      bottom: 10px;
    }
  }
  .w1380 {
    width: calc(100% - 40px);
    max-width: 1380px;
    min-width: 0;
    margin: 20px auto;
  }
  .author-content {
    position: absolute;
    background: #fff;
    box-shadow: 0 0 5px #d3d3d3;
    display: none;
    padding: 10px;
    z-index: 99999;
    width: 300px;
    top: 27px;
    left: 110px;
    .mb10 {
      font-size: 16px;
      margin-bottom: 10px !important;
    }
    .hui {
      margin-top: 5px !important;
    }
    p {
      font-size: 14px;
      margin: 0 !important;
      span {
        position: relative;
        &:first-of-type {
          margin-right: 14px;
          &::before {
            content: "";
            position: absolute;
            width: 1px;
            height: 14px;
            background: #ccc;
            right: -7px;
            top: 50%;
            margin-top: -7px;
          }
        }
        label {
          color: #2d8cf0;
        }
      }
    }
  }
  .right_list {
    flex: 1;
    min-width: 0;
    .right-top {
      background: #fff;
      margin-bottom: 20px;
    }
    .mbborder {
      border-bottom: 1px solid #eeeeee;
    }
    .filter {
      display: flex;
      flex-wrap: wrap;
      align-items: center;

      padding: 15px;
      line-height: 30px;

      .searchword {
        margin-right: 20px;
        .red {
          color: #ff0000;
        }

        label {
          color: #2d8cf0;
        }
      }

      .flex {
        display: inline-block;
        border: 1px solid #cccccc;
        color: #2d8cf0;
        font-size: 14px;
        padding: 2px 5px;
        margin-right: 10px;
        i {
          margin-left: 5px;
          font-size: 12px;
          color: #999999;
          cursor: pointer;
        }
      }
      .total {
        span {
          color: #ff0000;
        }
      }
      .search {
        background: #fff;
        border: 1px solid #cccccc;
        width: 400px;
        position: relative;
        display: flex;
        ::v-deep .el-input__inner {
          border: none;
          border-radius: 0;
          height: 35px;
          line-height: 35px;
        }
        ::v-deep .el-input__icon {
          line-height: 35px;
        }
        .el-select {
          position: relative;
          width: 130px;
          &::after {
            content: "";
            position: absolute;
            right: 0;
            top: 7px;
            width: 1px;
            height: 20px;
            background: #cccccc;
          }
        }
        .el-input {
          flex: 1;
        }
        .search_img {
          width: 40px;
          height: 35px;
          background: #2d8cf0;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        }
      }
    }
    .between {
      justify-content: space-between;
    }
    .sort-item {
      display: flex;
      border-bottom: 1px solid #eee;
      padding: 20px;
      background: #fff;

      p {
        margin-right: 30px;
        font-size: 16px;
        font-weight: bold;
        display: inline-block;
        cursor: pointer;
        position: relative;
        &:hover {
          color: #2d8cf0;
          &::before {
            content: "";
            position: absolute;
            bottom: -21px;
            left: 50%;
            margin-left: -25px;
            height: 2px;
            width: 50px;
            z-index: 88;
            background: #2d8cf0;
          }
        }
      }
      .checked {
        color: #2d8cf0;
        position: relative;
        &::before {
          content: "";
          position: absolute;
          bottom: -21px;
          left: 50%;
          margin-left: -25px;
          height: 2px;
          width: 50px;
          z-index: 88;
          background: #2d8cf0;
        }
      }
    }
    .right-info {
      background: #fff;
    }
    .right-list {
      padding: 0 20px;
      color: #666;
      li {
        display: flex;
        padding: 20px 0;
        border-bottom: 1px dashed #eeeeee;
        .right_index {
          width: 65px;
        }
        .right-content {
          flex: 1;
          min-width: 0;
          .hover {
            cursor: pointer;
            color: #2d8cf0;
            &:hover {
              color: #2d8cf0 !important;
              text-decoration: underline;
            }
          }
        }
      }
      .title {
        color: #333;
        font-size: 18px;
        font-weight: bold;
        cursor: pointer;
        margin-bottom: 10px;
        &:hover {
          background-image: linear-gradient(to right, #006eb3, #2d8cf0);
          background-clip: text;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          label {
            -webkit-text-fill-color: initial;
          }
        }
      }
      .num {
        margin-bottom: 8px;
        span {
          display: inline-block;
          border: 1px solid #ccc;
          font-size: 14px;
          padding: 3px 8px;
          margin-right: 10px;
        }
      }
      p {
        margin-bottom: 8px;
      }
      .setting {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .setting-span {
          span {
            cursor: pointer;
            margin-right: 20px;
            &:hover {
              color: #2d8cf0;
            }
            i {
              margin-right: 5px;
            }
          }
          .checked {
            color: #2d8cf0;
          }
        }
        .collect {
          color: #2d8cf0;
        }
        .follow {
          cursor: pointer;

          &:hover {
            color: #2d8cf0;
          }
          i {
            margin-right: 5px;
          }
          label {
            position: relative;
            padding-left: 5px;
          }
        }
      }
      .chindren-page {
        border-top: 1px dashed #eeeeee;
        margin-top: 15px;
        padding-top: 15px;
      }
      .empty-result {
        color: #999;
        line-height: 32px;
        text-align: center;
      }
      .result-loading {
        color: #2d8cf0;
        line-height: 32px;
        text-align: center;

        i {
          margin-right: 6px;
        }
      }
      .chindren-page1 {
        .page1-list {
          border-bottom: 1px dotted #dadce0;
          padding: 20px 0;
          &:nth-of-type(1) {
            padding-top: 0;
          }
          .page1-title {
            cursor: pointer;
            &:hover {
              color: #2d8cf0;
            }
          }
          .small {
            font-size: 12px;
            span {
              color: #2d8cf0;
              margin-left: 5px;
            }
          }
          p {
            &:last-of-type {
              margin: 0;
            }
            .span_a {
              font-size: 14px;
            }
          }
          &:last-of-type {
            border-bottom: none;
            padding-bottom: 0;
          }
          .author-list-container {
            display: block;
            margin-bottom: 8px;
          }
          .span-content {
            display: inline-block;
            position: relative;
            .author1-content {
              top: 30px;
              left: 0px;
            }
          }
          .green_span {
            cursor: pointer;
            &:hover {
              .span_a {
                text-decoration: underline;
              }
              transition: all 1s;
              .author1-content {
                display: inline-block;
              }
            }
            .span_a {
              color: #2d8cf0;
            }
          }
          .author1-content {
            position: absolute;
            background: #fff;
            box-shadow: 0 0 5px #d3d3d3;
            display: none;
            padding: 10px;
            z-index: 9999;
            top: -30px;
            right: -210px;
            min-width: 300px;
            .mb10 {
              font-size: 16px;
              margin-bottom: 10px !important;
            }
            .hui {
              margin-top: 5px !important;
              white-space: pre-wrap;
            }
            p {
              font-size: 14px;
              margin: 0 !important;
              white-space: nowrap;
              line-height: 20px;
              span {
                position: relative;
                &:first-of-type {
                  margin-right: 14px;
                  &::before {
                    content: "";
                    position: absolute;
                    width: 1px;
                    height: 14px;
                    background: #ccc;
                    right: -7px;
                    top: 50%;
                    margin-top: -7px;
                  }
                }
                label {
                  color: #2d8cf0;
                }
              }
            }
          }
        }
      }
      .chindren-page2 {
        .children-list {
          border-left: 1px dotted #dadce0;
          position: relative;
          padding-left: 20px;
          margin-bottom: 10px;
          &:hover {
            .author-content {
              display: inline-block;
            }
          }
          &:last-of-type {
            margin: 0;
          }
          .page2-title {
            color: #333;
            cursor: pointer;
            margin: 5px 0;
            &:hover {
              color: #2d8cf0;
            }
          }
          .small {
            font-size: 12px;
            span {
              color: #2d8cf0;
            }
          }
          p {
            margin-bottom: 0;
          }
          &::after {
            content: "";
            left: 0;
            width: 7px;
            height: 7px;
            background: #dadce0;
            border-radius: 50%;
            top: 0;
            transform: translateX(-50%);
            position: absolute;
          }
        }
      }
    }
  }
}
.btndiv {
  margin-top: 20px;
  text-align: right;
}
.follow-btn-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  .follow-btn {
    margin: 10px 5px;
    padding: 15px 20px;
    min-width: 220px;
    border-radius: 6px;
    font-size: 14px;
    transition: all 0.3s ease;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  .follow-btn i {
    margin-right: 5px;
  }
  .subscribe-btn {
    background-color: #409eff;
    border-color: #409eff;
  }
  .cancel-btn {
    background-color: #f56c6c;
    border-color: #f56c6c;
    color: white;
  }
}
/* 联想词弹出层样式 */
.search-input {
  position: absolute;
  top: 50px;
  left: 0px;
  width: 90%;
  max-height: 300px;
  overflow-y: auto;
  background: white;
  border: 1px solid #ddd;
  border-top: none;
  border-radius: 0 0 4px 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  ul {
    margin: 0;
    padding: 0;
    li {
      padding: 8px 16px;
      cursor: pointer;
      transition: background-color 0.2s;
      &:hover {
        background-color: #f5f7fa;
      }
    }
  }
}

::v-deep .el-dialog {
  max-width: calc(100vw - 32px);
}

@media (max-width: 1024px) {
  .container {
    .w1380 {
      flex-direction: column;
    }

    .left_list,
    .right_list {
      width: 100%;
    }

    .left_list {
      margin-bottom: 12px;
    }
  }

  ::v-deep .container_menu {
    width: 100%;
    max-width: none;
    min-height: 0;
    margin-right: 0;

    .menu .menu-list {
      max-height: 280px;
    }
  }
}

@media (max-width: 768px) {
  .container {
    .article-search {
      height: auto;
      min-height: 220px;
      padding: 24px 0 12px;

      .search-wapper {
        width: calc(100% - 24px);
      }

      h3 {
        font-size: 21px;
        line-height: 1.5;
      }

      .search .search_div {
        align-items: stretch;
        flex-direction: column;
        width: 100%;
        margin-top: 20px;

        .title-select {
          width: 100%;
          margin: 0 0 8px;

          ::v-deep .el-input__inner {
            height: 42px;
          }
        }
      }

      .search .searchLeft {
        width: 100%;
        height: 44px;

        ::v-deep .el-input__inner {
          height: 42px;
        }

        .inputDiv .search-btn {
          width: 52px;
          height: 36px;
        }
      }

      .search_nav {
        position: static;
        margin-top: 12px;
      }
    }

    .w1380 {
      width: calc(100% - 24px);
      margin: 12px auto;
    }

    .right_list {
      .right-top {
        margin-bottom: 12px;
      }

      .filter {
        align-items: flex-start;
        padding: 12px;
      }

      .sort-item {
        padding: 16px 12px;
        overflow-x: auto;

        p {
          flex: 0 0 auto;
          margin-right: 24px;
          white-space: nowrap;

          &:hover::before {
            bottom: -17px;
          }
        }

        .checked::before {
          bottom: -17px;
        }
      }

      .right-list {
        padding: 0 12px;

        li {
          padding: 16px 0;

          .right_index {
            width: 32px;
            flex: 0 0 32px;
          }
        }

        .title {
          font-size: 16px;
          overflow-wrap: anywhere;
        }

        .num {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;

          span {
            margin-right: 0;
          }
        }

        .setting {
          align-items: flex-start;
          flex-direction: column;
          gap: 12px;

          .setting-span {
            display: flex;
            flex-wrap: wrap;
            gap: 10px 18px;

            span {
              margin-right: 0;
            }
          }
        }

        .author1-content {
          left: 0;
          right: auto;
          min-width: 0;
          width: min(300px, calc(100vw - 80px));
          box-sizing: border-box;

          p {
            white-space: normal;
          }
        }
      }
    }

    .author-content {
      left: 0;
      width: min(300px, calc(100vw - 64px));
      max-width: 100%;
    }
  }

  .search-input {
    top: 44px;
    width: 100%;
  }

  ::v-deep .el-pagination {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 8px 0;
    padding: 16px 8px;
    white-space: normal;

    .el-pagination__sizes,
    .el-pagination__jump {
      margin-left: 0;
    }
  }
}

@media (max-width: 480px) {
  .container .right_list .right-list li .right_index {
    display: none;
  }

  ::v-deep .el-pagination {
    .el-pagination__total,
    .el-pagination__sizes,
    .el-pagination__jump {
      display: none;
    }
  }

  .follow-btn-box .follow-btn {
    width: 100%;
    min-width: 0;
  }
}
</style>
